<svg
	width="22px"
	height="22px"
	viewBox="0 0 22 22"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
>
	<g id="Overview" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<g
			id="Action"
			transform="translate(-113.000000, -930.000000)"
			fill="currentColor"
			fill-rule="nonzero"
		>
			<g id="Group" transform="translate(112.000000, 929.000000)">
				<path
					d="M12,0.999999954 C5.92499997,0.999999954 0.999999954,5.92499997 0.999999954,12 C0.999999954,18.075 5.92499997,23 12,23 C18.075,23 23,18.075 23,12 C23,5.92499997 18.075,0.999999954 12,0.999999954 Z M12,21.5 C6.76149998,21.5 2.49999996,17.2385 2.49999996,12 C2.49999996,6.76149998 6.76149998,2.49999996 12,2.49999996 C17.2385,2.49999996 21.5,6.76149998 21.5,12 C21.5,17.2385 17.2385,21.5 12,21.5 Z"
					id="Shape"
				></path>
				<path
					d="M16.4695,8.23599998 L10.6665,14.039 L7.53049998,10.903 C7.23749998,10.61 6.76299998,10.61 6.46999998,10.903 C6.17699998,11.1955 6.17699998,11.671 6.46999998,11.9635 L10.667,16.1605 L17.531,9.29699999 C17.824,9.00449999 17.824,8.52949999 17.531,8.23649998 C17.238,7.94349998 16.7625,7.94299998 16.4695,8.23599998 Z"
					id="Path"
				></path>
			</g>
		</g>
	</g>
</svg>
